import { buildProps } from '@element-plus/utils'
import type Trend from './trend.vue'
import type { ExtractPropTypes } from 'vue'

export const trendProps = buildProps({
  /**
   * @description trend flag
   */
  flag: {
    type: String,
    values: ['up', 'down'],
    default: '',
  },
  /**
   * @description whether to display with color
   */
  color: {
    type: Boolean,
    default: true,
  },
  /**
   * @description whether the color is inverted, assuming the color is displayed
   */
  reverseColor: {
    type: Boolean,
    default: false,
  },
  /**
   * @description whether the text display with color, ifluenced by color and reverse-color
   */
  textColor: {
    type: Boolean,
    default: false,
  },
  /**
   * @description the vertical alignment of the text and tren icon
   */
  align: {
    type: String,
    values: ['top', 'bottom', 'center', 'baseline'],
    default: 'baseline',
  },
} as const)

export type TrendProps = ExtractPropTypes<typeof trendProps>
export type TrendInstance = InstanceType<typeof Trend>
